import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { selectUserId } from '@/store/selectors/userSelectors';
import { selectLocale } from '@/store/selectors/commonSelectors';

const useSentry = (): void => {
  const userId = useSelector(selectUserId);
  const locale = useSelector(selectLocale);

  useEffect(() => {
    if (userId) {
      Sentry.setUser({ id: `${userId}` });
    } else {
      Sentry.setUser(null);
    }
  }, [userId]);

  useEffect(() => {
    Sentry.setTag('locale', locale);
  }, [locale]);
};

export default useSentry;
